const initialState = {
    pending: false,
    gateSwitchers: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: ''},
    selected: {}
};


const gateSwitchersReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_GATE_SWITCHERS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_GATE_SWITCHERS_SUCCESS':
            return {
                ...state,
                pending: false,
                gateSwitchers: action.gateSwitchers,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount
            };
        case 'GET_GATE_SWITCHERS_ALERT_RULES_SUCCESS':
            return {
                ...state,
                gateSwitchersAlertRules: action.gateSwitchersAlertRules
            }
        case 'GET_GATE_SWITCHERS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_GATE_SWITCHER':
            return {
                ...state,
                selected: action.selected
            };
        case 'SET_GATE_SWITCHERS_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        case 'ADD_GATE_SWITCHER_SUCCESS':
            return {
                ...state,
                pending: false
            };
        default:
            return state;
    }
}

export default gateSwitchersReducer;
